export default __webpack_public_path__ + "static/media/property-icon.778b9667.svg";